import { createSlice } from "@reduxjs/toolkit";
import { CampaignReducerState, defaultCampaignFilters } from "types/campaign";
import { fetchAllCampaignsThunk, fetchCampaignThunk } from "./thunk";

const initialState: CampaignReducerState = {
    loading: false,
    error: null,
    filters: defaultCampaignFilters,
    applied_filter_id: null,
    total: 0,
    filtered_lists: {},
    all_campaigns: [],
    last_fetched_at: null,
    campaignLoading: false,
    campaigns: {},
}

const campaigns = createSlice({
    name: 'campaigns',
    initialState,
    reducers: {
        updateCampaignsFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCampaignsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllCampaignsThunk.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.error = null;
                const { count, items } = payload;
                state.all_campaigns = items;
                state.total = count;
                state.last_fetched_at = Date.now();
            })
            .addCase(fetchAllCampaignsThunk.rejected, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchCampaignThunk.pending, (state) => {
                state.campaignLoading = true;
                state.error = null;
            })
            .addCase(fetchCampaignThunk.fulfilled, (state, { payload }) => {
                state.campaignLoading = false;
                state.error = null;
                state.campaigns[payload.campaignId] = { data: payload.data, last_fetched_at: Date.now() };
            })
            .addCase(fetchCampaignThunk.rejected, (state) => {
                state.campaignLoading = false;
                state.error = null;
            })  
    }
})

export const { updateCampaignsFilters } = campaigns.actions;
export default campaigns.reducer;